export type ApiResult<T> = { ok: true; status: number; data: T } | { ok: false; status: number; error: { code: string; message: string } };

export async function api<T>(method: string, path: string, body?: unknown): Promise<ApiResult<T>> {
  let res: Response;
  try {
    res = await fetch(path, {
      method,
      credentials: 'same-origin',
      headers: body === undefined ? {} : { 'content-type': 'application/json' },
      body: body === undefined ? undefined : JSON.stringify(body),
    });
  } catch {
    return { ok: false, status: 0, error: { code: 'network', message: 'Network error. Check your connection and try again.' } };
  }
  const json = await res.json().catch(() => null);
  if (res.ok) return { ok: true, status: res.status, data: json as T };
  return { ok: false, status: res.status, error: json?.error ?? { code: 'http_' + res.status, message: `Request failed (${res.status}).` } };
}
